import { render, staticRenderFns } from "./paypal_button.vue?vue&type=template&id=1c317006&scoped=true&"
import script from "./paypal_button.vue?vue&type=script&lang=js&"
export * from "./paypal_button.vue?vue&type=script&lang=js&"
import style0 from "./paypal_button.vue?vue&type=style&index=0&id=1c317006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c317006",
  null
  
)

export default component.exports